import { IconButton, InputBase } from '@mui/material'
import SearchIcon from '@mui/icons-material/Search'
import CloseIcon from '@mui/icons-material/Close'

import { useManageSelectedTodo } from '../useManageSelectedTodo'
import { TOOLBAR_ICON_BUTTON_SX } from '../toolbarSx'
import { BffCrmPersonChatRetrieveResponse } from '@fireflyhealth/api'

const CaseMessageSearch = (props: {
  case: NonNullable<BffCrmPersonChatRetrieveResponse['case']>
}) => {
  const { navigateToCase } = useManageSelectedTodo()

  const handleClose = () => {
    navigateToCase(null)
  }

  return (
    <>
      <IconButton
        sx={TOOLBAR_ICON_BUTTON_SX}
        style={{ backgroundColor: 'transparent', cursor: 'default' }}
      >
        <SearchIcon />
      </IconButton>
      <InputBase
        placeholder="Search thread"
        inputProps={{ 'aria-label': 'search thread' }}
        value={props.case.category.title}
        fullWidth
      />
      <IconButton sx={TOOLBAR_ICON_BUTTON_SX} onClick={handleClose}>
        <CloseIcon />
      </IconButton>
    </>
  )
}

export default CaseMessageSearch
